import Model from '@/models/Model'

export default class AAuthorize extends Model {
    resource() {
        return 'authorize'
    }
}
